import { DatabaseEntities } from "../../../common/models/database-entities.model";

export class SpreaderHeights extends DatabaseEntities<SpreaderHeights> {
    value: string;
}
